import { DetailsEditor, FormContainer } from "uikit"
import React from "react"
import { Button, Dropdown, Grid } from "semantic-ui-react"
import { useStore } from "store"
import { incomeTypes } from "./incomeTypes"

const getIncomeTypeOptions = ({ people, incomes }) => {
  const hasChildren = people.filter(p => p.role === "child").length > 0
  const hasSpouse = people.filter(p => p.role === "spouse").length > 0
  const hasRental = incomes.filter(i => i.type === "rental").length > 0
  return Object.keys(incomeTypes)
    .filter(type => {
      if (!hasChildren && type === "childsupport") {
        return false
      }
      if (hasSpouse && type === "alimony") {
        return false
      }
      if (hasRental && type === "rental") {
        return false
      }
      if (incomeTypes[type].validator === undefined) {
        return true
      }
      return incomeTypes[type].validator({ people })
    })
    .map(incomeType => ({
      value: incomeType,
      text: incomeTypes[incomeType].label
    }))
}

const IncomeTypeSelectGrid = ({
  data: {
    fields: { incomeType },
    onSubmit
  },
  submitLabel = "Continue",
  onCancel,
  household
}) => {
  const [peopleObject] = useStore("householdPeople", household.id)
  const [incomesObject] = useStore("householdIncomes", household.id)
  const people = Object.values(peopleObject)
  const incomes = Object.values(incomesObject)
  return (
    <DetailsEditor heading="Add Income Source">
      <Grid>
        <Grid.Row
          style={{
            background: "#edf7ff",
            padding: "3em",
            borderTop: "1px solid #ccc"
          }}
        >
          <Grid.Column textAlign="center">
            <Dropdown
              placeholder="Select Type of Income"
              data-testid="income_type"
              selection
              options={getIncomeTypeOptions({ people, incomes })}
              {...incomeType}
              error={!!incomeType.error}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row centered style={{ minHeight: "20em" }}>
          <Grid.Column
            width={10}
            textAlign="center"
            style={{ fontSize: "16px", paddingTop: "21px", color: "#aaa" }}
          >
            {incomeType.value
              ? incomeTypes[incomeType.value].description
              : "Please select the type of income you wish to add."}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row style={{ borderTop: "1px solid #ccc" }} columns={2}>
          <Grid.Column textAlign="left" style={{ paddingLeft: "2em" }}>
            <Button
              basic
              data-testid="cancel"
              content="Cancel"
              onClick={onCancel}
              primary
            />
          </Grid.Column>
          <Grid.Column textAlign="right" style={{ paddingRight: "2em" }}>
            <Button
              data-testid="submit"
              content={submitLabel}
              onClick={onSubmit}
              primary
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </DetailsEditor>
  )
}

const IncomeTypeSelector = FormContainer(
  {
    incomeType: {
      type: "string",
      required: true
    }
  },
  (fields, ...form) => {}
)(IncomeTypeSelectGrid)

export default IncomeTypeSelector
